import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { ScoreCard } from '../../../components/cards';
import SectionHeading from '../../../components/text/SectionHeading';
import SectionHeadingWrapper from '../../../components/text/SectionHeading/HeadingWrapper';
import { MatchFormatTypes } from '../../../utils/postScoreConstants';

const PendingResults = ({ pendingResults, auth }) => {
    const [showAll, setShowAll] = useState();

    return (
        <>
            {(pendingResults?.length > 0) ? (
                <>
                    <div className="row mt64">
                        <div className="col-12">
                            <SectionHeadingWrapper>
                                <SectionHeading title={'Pending results'} data-testid="dashboard.pending-results.section-heading" />
                                {pendingResults?.length > 3 && (
                                    <div className={`link clickable`} onClick={() => setShowAll(!showAll)} data-testid="dashboard.pending-results.view-toggle">
                                        {showAll ? 'View Less' : 'View All'}
                                    </div>
                                )}
                            </SectionHeadingWrapper>
                        </div>
                    </div>
                    <div className="row mb64">
                        {pendingResults.map((pendingResult, i) => {
                            if (i < 3 || showAll) {
                                return (
                                    <div className={`col-12 col-md-6 col-xl-4`} key={`${pendingResult.id}`}>
                                        <ScoreCard
                                            key={`pending-match-item-${pendingResult.id}`}
                                            {...pendingResult}
                                            gameType={pendingResult?.players?.winner2 || pendingResult?.players?.loser2 ? MatchFormatTypes.DOUBLES : MatchFormatTypes.SINGLES}
                                            playerId={auth.user.claimedPlayer.playerId}
                                            timeZoneValue={'UTC'}
                                            showVerified={false}
                                            forceCardView={true}
                                            data-testid={`dashboard.pending-results.item-${pendingResult.id}`}
                                        />
                                    </div>
                                );
                            }
                            return null;
                        })}
                    </div>
                </>
            ) : null}
        </>
    );
};

PendingResults.propTypes = {
    auth: PropTypes.instanceOf(Object).isRequired,
    pendingResults: PropTypes.instanceOf(Array),
};

PendingResults.defaultProps = {
    pendingResults: [],
};

export default PendingResults;
